import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-364adbef"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "marcas-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "marcas-content" };
const _hoisted_4 = { class: "content-header" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Gestión de Repuestos", -1 /* HOISTED */));
const _hoisted_6 = { class: "header-top-controls" };
const _hoisted_7 = { class: "search-container" };
const _hoisted_8 = { class: "search-wrapper" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Generar Reporte", -1 /* HOISTED */));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Nuevo Repuesto", -1 /* HOISTED */));
const _hoisted_11 = { class: "filter-controls" };
const _hoisted_12 = { class: "alphabet-filter" };
const _hoisted_13 = ["onClick"];
const _hoisted_14 = { class: "dropdown-filters" };
const _hoisted_15 = { class: "filter-group autocomplete" };
const _hoisted_16 = {
    key: 0,
    class: "autocomplete-list filter-autocomplete"
};
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("em", null, "Todos los Departamentos", -1 /* HOISTED */));
const _hoisted_18 = [
    _hoisted_17
];
const _hoisted_19 = ["onMousedown", "innerHTML"];
const _hoisted_20 = ["disabled"];
const _hoisted_21 = {
    key: 0,
    class: "autocomplete-list filter-autocomplete"
};
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("em", null, "Todas las Categorías", -1 /* HOISTED */));
const _hoisted_23 = [
    _hoisted_22
];
const _hoisted_24 = ["onMousedown", "innerHTML"];
const _hoisted_25 = { class: "table-container" };
const _hoisted_26 = { class: "marcas-table" };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Nombre del Repuesto"),
        /*#__PURE__*/ _createElementVNode("th", null, "Departamento"),
        /*#__PURE__*/ _createElementVNode("th", null, "Categoría"),
        /*#__PURE__*/ _createElementVNode("th", null, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "actions-column" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_28 = { key: 0 };
const _hoisted_29 = {
    colspan: "5",
    class: "text-center py-8"
};
const _hoisted_30 = { class: "loading-state" };
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-muted" }, "Cargando repuestos...", -1 /* HOISTED */));
const _hoisted_32 = { key: 1 };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "4",
    class: "text-center py-4 text-muted"
}, "No se encontraron resultados.", -1 /* HOISTED */));
const _hoisted_34 = [
    _hoisted_33
];
const _hoisted_35 = { class: "attribute-badge" };
const _hoisted_36 = { class: "text-center" };
const _hoisted_37 = { class: "actions-wrapper" };
const _hoisted_38 = ["onClick", "title"];
const _hoisted_39 = ["onClick"];
const _hoisted_40 = ["onClick"];
const _hoisted_41 = ["onClick"];
const _hoisted_42 = { class: "pagination-controls" };
const _hoisted_43 = ["disabled"];
const _hoisted_44 = ["disabled"];
const _hoisted_45 = { class: "total-count-display" };
const _hoisted_46 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_47 = { class: "modal-header" };
const _hoisted_48 = { class: "modal-title-group" };
const _hoisted_49 = { class: "icon-bg" };
const _hoisted_50 = { class: "modal-title" };
const _hoisted_51 = {
    class: "export-info-card",
    style: { "margin-bottom": "24px" }
};
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Ingrese la información básica para catalogar el nuevo repuesto en el sistema.", -1 /* HOISTED */));
const _hoisted_53 = {
    key: 0,
    class: "creation-mode-toggle",
    style: { "margin-bottom": "20px", "display": "flex", "gap": "10px", "background": "#f1f5f9", "padding": "4px", "border-radius": "8px" }
};
const _hoisted_54 = { style: { "display": "flex", "flex-direction": "column" } };
const _hoisted_55 = {
    class: "form-group premium-input",
    style: { "margin-bottom": "20px" }
};
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Departamento", -1 /* HOISTED */));
const _hoisted_57 = { class: "input-with-icon autocomplete" };
const _hoisted_58 = ["required"];
const _hoisted_59 = {
    key: 0,
    class: "autocomplete-list filter-autocomplete"
};
const _hoisted_60 = ["onMousedown", "innerHTML"];
const _hoisted_61 = {
    class: "form-group premium-input",
    style: { "margin-bottom": "0" }
};
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Categoría", -1 /* HOISTED */));
const _hoisted_63 = { class: "input-with-icon autocomplete" };
const _hoisted_64 = ["disabled", "required"];
const _hoisted_65 = {
    key: 0,
    class: "autocomplete-list"
};
const _hoisted_66 = ["onMousedown", "innerHTML"];
const _hoisted_67 = {
    key: 0,
    class: "form-group premium-input",
    style: { "order": "1" }
};
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Nombre del Repuesto", -1 /* HOISTED */));
const _hoisted_69 = { class: "input-with-icon" };
const _hoisted_70 = ["required"];
const _hoisted_71 = {
    key: 1,
    style: { "order": "2" }
};
const _hoisted_72 = {
    key: 0,
    class: "form-group premium-input",
    style: { "animation": "modalSlideUp 0.3s ease-out" }
};
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Nombres de los Repuestos", -1 /* HOISTED */));
const _hoisted_74 = { style: { "max-height": "350px", "overflow-y": "auto", "padding-right": "10px", "margin-bottom": "10px" } };
const _hoisted_75 = {
    class: "input-with-icon",
    style: { "flex": "1" }
};
const _hoisted_76 = ["onUpdate:modelValue", "required"];
const _hoisted_77 = ["onClick"];
const _hoisted_78 = {
    key: 1,
    class: "export-info-card",
    style: { "background": "#fffbeb", "border-color": "#fde68a" }
};
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { style: { "color": "#92400e" } }, "Selecciona primero el Departamento y la Categoría para empezar a agregar los nombres de los repuestos.", -1 /* HOISTED */));
const _hoisted_80 = { class: "modal-footer" };
const _hoisted_81 = ["disabled"];
const _hoisted_82 = ["disabled"];
const _hoisted_83 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_84 = { class: "modal-window large-modal" };
const _hoisted_85 = { class: "modal-header" };
const _hoisted_86 = { class: "modal-title-group" };
const _hoisted_87 = { class: "icon-bg purple" };
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Configurar Desplegables", -1 /* HOISTED */));
const _hoisted_89 = { class: "subtitle" };
const _hoisted_90 = { class: "modal-body" };
const _hoisted_91 = { class: "add-value-box" };
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "box-label" }, "Vincular atributo existente:", -1 /* HOISTED */));
const _hoisted_93 = { class: "input-group autocomplete-wrapper" };
const _hoisted_94 = { class: "input-with-icon full-width" };
const _hoisted_95 = {
    key: 0,
    class: "autocomplete-list"
};
const _hoisted_96 = ["onClick"];
const _hoisted_97 = ["disabled"];
const _hoisted_98 = { class: "values-list-container" };
const _hoisted_99 = { class: "marcas-table mini-table" };
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { style: { "width": "40px" } }),
        /*#__PURE__*/ _createElementVNode("th", null, "Nombre Atributo"),
        /*#__PURE__*/ _createElementVNode("th", {
            class: "text-right",
            style: { "width": "80px" }
        }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_101 = { id: "sortable" };
const _hoisted_102 = { class: "drag-handle" };
const _hoisted_103 = { class: "actions-column" };
const _hoisted_104 = ["onClick"];
const _hoisted_105 = { key: 0 };
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "3",
    class: "text-center text-muted py-3"
}, "Sin atributos vinculados.", -1 /* HOISTED */));
const _hoisted_107 = [
    _hoisted_106
];
const _hoisted_108 = {
    key: 0,
    class: "drag-hint"
};
const _hoisted_109 = { class: "modal-footer" };
const _hoisted_110 = { class: "modal-window export-modal premium-modal" };
const _hoisted_111 = { class: "modal-header" };
const _hoisted_112 = { class: "modal-title-group" };
const _hoisted_113 = { class: "icon-bg excel-bg" };
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "modal-title" }, "Generar Reporte"),
    /*#__PURE__*/ _createElementVNode("p", { class: "modal-subtitle" }, "Seleccione los parámetros del reporte")
], -1 /* HOISTED */));
const _hoisted_115 = { class: "modal-body" };
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "export-info-card" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-information info-icon" }),
    /*#__PURE__*/ _createElementVNode("p", null, "Seleccione los filtros y columnas para su reporte. Se incluirán los registros según los filtros de búsqueda actuales.")
], -1 /* HOISTED */));
const _hoisted_117 = { class: "export-section" };
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Formato de Salida", -1 /* HOISTED */));
const _hoisted_119 = { class: "export-format-grid" };
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "export-format-card-content" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-name" }, "Excel (.xlsx)"),
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-desc" }, "Hoja de cálculo editable")
], -1 /* HOISTED */));
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "export-format-card-content" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-name" }, "PDF (.pdf)"),
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-desc" }, "Documento listo para imprimir")
], -1 /* HOISTED */));
const _hoisted_122 = {
    class: "export-section",
    style: { "margin-top": "24px" }
};
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Ordenar Por", -1 /* HOISTED */));
const _hoisted_124 = {
    class: "export-format-grid",
    style: { "grid-template-columns": "2fr 1fr", "gap": "10px" }
};
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Nombre" }, "Nombre del Repuesto", -1 /* HOISTED */));
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Departamento" }, "Departamento", -1 /* HOISTED */));
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Categoría" }, "Categoría", -1 /* HOISTED */));
const _hoisted_128 = [
    _hoisted_125,
    _hoisted_126,
    _hoisted_127
];
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "asc" }, "Ascendente", -1 /* HOISTED */));
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "desc" }, "Descendente", -1 /* HOISTED */));
const _hoisted_131 = [
    _hoisted_129,
    _hoisted_130
];
const _hoisted_132 = {
    class: "export-section",
    style: { "margin-top": "24px" }
};
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Columnas a Incluir", -1 /* HOISTED */));
const _hoisted_134 = { class: "columns-selection-grid" };
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "column-selection-header" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "header-order" }, "#"),
    /*#__PURE__*/ _createElementVNode("span", { class: "header-name" }, "Columna")
], -1 /* HOISTED */));
const _hoisted_136 = { class: "column-order-badge" };
const _hoisted_137 = {
    class: "drag-handle",
    title: "Arrastrar para reordenar"
};
const _hoisted_138 = { class: "checkbox-wrapper" };
const _hoisted_139 = ["value"];
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "checkmark" }, null, -1 /* HOISTED */));
const _hoisted_141 = { class: "column-details" };
const _hoisted_142 = { class: "column-name" };
const _hoisted_143 = { class: "modal-footer" };
const _hoisted_144 = ["disabled"];
const _hoisted_145 = { key: 0 };
const _hoisted_146 = {
    key: 1,
    class: "btn-content"
};
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Generar Reporte", -1 /* HOISTED */));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_FileTextIcon = _resolveComponent("FileTextIcon");
    const _component_PlusIcon = _resolveComponent("PlusIcon");
    const _component_LayersIcon = _resolveComponent("LayersIcon");
    const _component_GridIcon = _resolveComponent("GridIcon");
    const _component_Loader2Icon = _resolveComponent("Loader2Icon");
    const _component_PowerIcon = _resolveComponent("PowerIcon");
    const _component_ListIcon = _resolveComponent("ListIcon");
    const _component_EditIcon = _resolveComponent("EditIcon");
    const _component_TrashIcon = _resolveComponent("TrashIcon");
    const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon");
    const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon");
    const _component_PackageIcon = _resolveComponent("PackageIcon");
    const _component_XIcon = _resolveComponent("XIcon");
    const _component_InfoIcon = _resolveComponent("InfoIcon");
    const _component_TagIcon = _resolveComponent("TagIcon");
    const _component_MoveIcon = _resolveComponent("MoveIcon");
    const _component_DownloadIcon = _resolveComponent("DownloadIcon");
    const _component_GripVerticalIcon = _resolveComponent("GripVerticalIcon");
    const _component_draggable = _resolveComponent("draggable");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_SearchIcon, {
                                    size: 18,
                                    class: "search-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.searchQuery) = $event)),
                                    placeholder: "Buscar repuesto...",
                                    class: "search-input"
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, $setup.searchQuery]
                                ])
                            ])
                        ]),
                        _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => ($setup.openExportModal && $setup.openExportModal(...args))),
                            class: "btn btn-export-premium"
                        }, [
                            _createVNode(_component_FileTextIcon, { size: 18 }),
                            _hoisted_9
                        ]),
                        ($setup.can($setup.P.REPUESTOS.CREATE))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[2] || (_cache[2] = ($event) => ($setup.openModal())),
                                class: "btn btn-add"
                            }, [
                                _createVNode(_component_PlusIcon, { size: 18 }),
                                _hoisted_10
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("button", {
                                onClick: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => ($setup.resetFilter && $setup.resetFilter(...args))),
                                class: _normalizeClass([{ active: !$setup.selectedLetter }, "alphabet-button all-button"])
                            }, " Todos ", 2 /* CLASS */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.alphabet, (letter) => {
                                return (_openBlock(), _createElementBlock("button", {
                                    key: letter,
                                    onClick: ($event) => ($setup.filterByLetter(letter)),
                                    class: _normalizeClass([{ active: $setup.selectedLetter === letter }, "alphabet-button"])
                                }, _toDisplayString(letter), 11 /* TEXT, CLASS, PROPS */, _hoisted_13));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _createCommentVNode(" Searchable Filters "),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_LayersIcon, {
                                    size: 16,
                                    class: "filter-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($setup.searchFilterDep) = $event)),
                                    onFocus: _cache[5] || (_cache[5] = ($event) => ($setup.showFilterDeps = true)),
                                    onBlur: _cache[6] || (_cache[6] =
                                        //@ts-ignore
                                        (...args) => ($setup.onBlurFilterDep && $setup.onBlurFilterDep(...args))),
                                    placeholder: "Departamento...",
                                    class: "filter-input"
                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                    [_vModelText, $setup.searchFilterDep]
                                ]),
                                ($setup.showFilterDeps && $setup.filteredFilterDepsList.length)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                                        _createElementVNode("li", {
                                            onMousedown: _cache[7] || (_cache[7] =
                                                //@ts-ignore
                                                (...args) => ($setup.clearFilterDep && $setup.clearFilterDep(...args))),
                                            class: "clear-option"
                                        }, _hoisted_18, 32 /* NEED_HYDRATION */),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredFilterDepsList, (dep) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: dep.departamentoID,
                                                onMousedown: ($event) => ($setup.selectFilterDep(dep)),
                                                innerHTML: dep.highlightedNombre
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_19));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("div", {
                                class: _normalizeClass(["filter-group autocomplete", { disabled: !$setup.filterDepartamentoId }])
                            }, [
                                _createVNode(_component_GridIcon, {
                                    size: 16,
                                    class: "filter-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (($setup.searchFilterCat) = $event)),
                                    onFocus: _cache[9] || (_cache[9] = ($event) => ($setup.showFilterCats = true)),
                                    onBlur: _cache[10] || (_cache[10] =
                                        //@ts-ignore
                                        (...args) => ($setup.onBlurFilterCat && $setup.onBlurFilterCat(...args))),
                                    placeholder: "Categoría...",
                                    class: "filter-input",
                                    disabled: !$setup.filterDepartamentoId
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_20), [
                                    [_vModelText, $setup.searchFilterCat]
                                ]),
                                ($setup.showFilterCats && $setup.filteredFilterCatsList.length)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                                        _createElementVNode("li", {
                                            onMousedown: _cache[11] || (_cache[11] =
                                                //@ts-ignore
                                                (...args) => ($setup.clearFilterCat && $setup.clearFilterCat(...args))),
                                            class: "clear-option"
                                        }, _hoisted_23, 32 /* NEED_HYDRATION */),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredFilterCatsList, (cat) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: cat.categoriaID,
                                                onMousedown: ($event) => ($setup.selectFilterCat(cat)),
                                                innerHTML: cat.highlightedNombre
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_24));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ], 2 /* CLASS */)
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("table", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("tbody", null, [
                            ($setup.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                                    _createElementVNode("td", _hoisted_29, [
                                        _createElementVNode("div", _hoisted_30, [
                                            _createVNode(_component_Loader2Icon, {
                                                class: "spinner-icon text-primary",
                                                size: 32
                                            }),
                                            _hoisted_31
                                        ])
                                    ])
                                ]))
                                : ($setup.paginatedRepuestos.length === 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_32, _hoisted_34))
                                    : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedRepuestos, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: item.repuestoID
                                }, [
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", _hoisted_35, _toDisplayString(item.nombre), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", null, _toDisplayString($setup.getNombreDepartamento(item.departamentoID)), 1 /* TEXT */),
                                    _createElementVNode("td", null, _toDisplayString($setup.getNombreCategoria(item.categoriaID)), 1 /* TEXT */),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["status-badge", item.active ? 'active' : 'inactive'])
                                        }, _toDisplayString(item.active ? 'Activo' : 'Inactivo'), 3 /* TEXT, CLASS */)
                                    ]),
                                    _createElementVNode("td", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("button", {
                                                onClick: ($event) => ($setup.toggleActive(item)),
                                                class: "btn-icon btn-toggle",
                                                title: item.active ? 'Desactivar' : 'Activar'
                                            }, [
                                                _createVNode(_component_PowerIcon, {
                                                    size: 18,
                                                    class: _normalizeClass(item.active ? 'text-success' : 'text-danger')
                                                }, null, 8 /* PROPS */, ["class"])
                                            ], 8 /* PROPS */, _hoisted_38),
                                            _createElementVNode("button", {
                                                onClick: ($event) => ($setup.openDesplegablesModal(item)),
                                                class: "btn-icon btn-view",
                                                title: "Configurar Desplegables"
                                            }, [
                                                _createVNode(_component_ListIcon, { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_39),
                                            ($setup.can($setup.P.REPUESTOS.EDIT))
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: ($event) => ($setup.editRepuesto(item)),
                                                    class: "btn-icon btn-edit",
                                                    title: "Editar Repuesto"
                                                }, [
                                                    _createVNode(_component_EditIcon, { size: 18 })
                                                ], 8 /* PROPS */, _hoisted_40))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.REPUESTOS.DELETE))
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 1,
                                                    onClick: ($event) => ($setup.confirmDeleteRepuesto(item.repuestoID)),
                                                    class: "btn-icon btn-delete",
                                                    title: "Eliminar"
                                                }, [
                                                    _createVNode(_component_TrashIcon, { size: 18 })
                                                ], 8 /* PROPS */, _hoisted_41))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("button", {
                        onClick: _cache[12] || (_cache[12] =
                            //@ts-ignore
                            (...args) => ($setup.prevPage && $setup.prevPage(...args))),
                        disabled: $setup.currentPage === 1,
                        class: "btn-pagination"
                    }, [
                        _createVNode(_component_ChevronLeftIcon, { size: 16 }),
                        _createTextVNode(" Anterior ")
                    ], 8 /* PROPS */, _hoisted_43),
                    _createElementVNode("span", null, [
                        _createTextVNode("Página "),
                        _createElementVNode("strong", null, _toDisplayString($setup.currentPage), 1 /* TEXT */),
                        _createTextVNode(" de "),
                        _createElementVNode("strong", null, _toDisplayString($setup.totalPages), 1 /* TEXT */)
                    ]),
                    _createElementVNode("button", {
                        onClick: _cache[13] || (_cache[13] =
                            //@ts-ignore
                            (...args) => ($setup.nextPage && $setup.nextPage(...args))),
                        disabled: $setup.currentPage === $setup.totalPages,
                        class: "btn-pagination"
                    }, [
                        _createTextVNode(" Siguiente "),
                        _createVNode(_component_ChevronRightIcon, { size: 16 })
                    ], 8 /* PROPS */, _hoisted_44)
                ]),
                _createElementVNode("div", _hoisted_45, " Total Registros: " + _toDisplayString($setup.totalRepuestosCount), 1 /* TEXT */),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isModalOpen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["modal-window", { 'large-modal': $setup.creationMode === 'bulk' && !$setup.isEditing }])
                                }, [
                                    _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("div", _hoisted_48, [
                                            _createElementVNode("div", _hoisted_49, [
                                                _createVNode(_component_PackageIcon, {
                                                    size: 24,
                                                    class: "text-primary"
                                                })
                                            ]),
                                            _createElementVNode("h2", _hoisted_50, _toDisplayString($setup.isEditing ? 'Editar Repuesto' : 'Nuevo Repuesto'), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[14] || (_cache[14] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("form", {
                                        onSubmit: _cache[28] || (_cache[28] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => ($setup.saveRepuesto && $setup.saveRepuesto(...args)), ["prevent"])),
                                        class: "modal-body"
                                    }, [
                                        _createElementVNode("div", _hoisted_51, [
                                            _createVNode(_component_InfoIcon, {
                                                size: 18,
                                                class: "text-primary"
                                            }),
                                            _hoisted_52
                                        ]),
                                        (!$setup.isEditing)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    style: _normalizeStyle([$setup.creationMode === 'individual' ? 'background: #fff; box-shadow: 0 1px 3px rgba(0,0,0,0.1); color: #0f172a;' : 'background: transparent; color: #64748b;', { "flex": "1", "padding": "8px", "border": "none", "border-radius": "6px", "font-weight": "600", "cursor": "pointer", "transition": "0.2s" }]),
                                                    onClick: _cache[15] || (_cache[15] = ($event) => ($setup.creationMode = 'individual'))
                                                }, "Individual", 4 /* STYLE */),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    style: _normalizeStyle([$setup.creationMode === 'bulk' ? 'background: #fff; box-shadow: 0 1px 3px rgba(0,0,0,0.1); color: #0f172a;' : 'background: transparent; color: #64748b;', { "flex": "1", "padding": "8px", "border": "none", "border-radius": "6px", "font-weight": "600", "cursor": "pointer", "transition": "0.2s" }]),
                                                    onClick: _cache[16] || (_cache[16] = ($event) => ($setup.creationMode = 'bulk'))
                                                }, "Múltiple", 4 /* STYLE */)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", _hoisted_54, [
                                            _createElementVNode("div", {
                                                class: "form-grid",
                                                style: _normalizeStyle([{ order: $setup.creationMode === 'bulk' ? 1 : 2 }, { "grid-template-columns": "1fr 1fr", "gap": "15px", "margin-bottom": "20px", "margin-top": "15px" }])
                                            }, [
                                                _createElementVNode("div", _hoisted_55, [
                                                    _hoisted_56,
                                                    _createElementVNode("div", _hoisted_57, [
                                                        _createVNode(_component_LayersIcon, {
                                                            size: 18,
                                                            class: "input-icon"
                                                        }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => (($setup.searchDepartamento) = $event)),
                                                            onFocus: _cache[18] || (_cache[18] = ($event) => ($setup.showDepartamentos = true)),
                                                            onBlur: _cache[19] || (_cache[19] =
                                                                //@ts-ignore
                                                                (...args) => ($setup.onBlurDepartamento && $setup.onBlurDepartamento(...args))),
                                                            class: "form-control",
                                                            placeholder: "Buscar departamento...",
                                                            required: $setup.currentForm.departamentoID === 0
                                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_58), [
                                                            [_vModelText, $setup.searchDepartamento]
                                                        ]),
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "number",
                                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => (($setup.currentForm.departamentoID) = $event)),
                                                            style: { "display": "none" },
                                                            min: "1",
                                                            required: ""
                                                        }, null, 512 /* NEED_PATCH */), [
                                                            [_vModelText, $setup.currentForm.departamentoID]
                                                        ]),
                                                        ($setup.showDepartamentos && $setup.filteredDepartamentosList.length > 0)
                                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_59, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredDepartamentosList, (dep) => {
                                                                    return (_openBlock(), _createElementBlock("li", {
                                                                        key: dep.departamentoID,
                                                                        onMousedown: _withModifiers(($event) => ($setup.selectDepartamento(dep)), ["prevent"]),
                                                                        innerHTML: dep.highlightedNombre
                                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_60));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_61, [
                                                    _hoisted_62,
                                                    _createElementVNode("div", _hoisted_63, [
                                                        _createVNode(_component_GridIcon, {
                                                            size: 18,
                                                            class: "input-icon"
                                                        }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => (($setup.searchCategoria) = $event)),
                                                            onFocus: _cache[22] || (_cache[22] = ($event) => ($setup.showCategorias = true)),
                                                            onBlur: _cache[23] || (_cache[23] =
                                                                //@ts-ignore
                                                                (...args) => ($setup.onBlurCategoria && $setup.onBlurCategoria(...args))),
                                                            class: "form-control",
                                                            placeholder: "Buscar categoría...",
                                                            disabled: !$setup.currentForm.departamentoID,
                                                            required: $setup.currentForm.categoriaID === 0
                                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_64), [
                                                            [_vModelText, $setup.searchCategoria]
                                                        ]),
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "number",
                                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => (($setup.currentForm.categoriaID) = $event)),
                                                            style: { "display": "none" },
                                                            min: "1",
                                                            required: ""
                                                        }, null, 512 /* NEED_PATCH */), [
                                                            [_vModelText, $setup.currentForm.categoriaID]
                                                        ]),
                                                        ($setup.showCategorias && $setup.filteredCategoriasList.length > 0)
                                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_65, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredCategoriasList, (cat) => {
                                                                    return (_openBlock(), _createElementBlock("li", {
                                                                        key: cat.categoriaID,
                                                                        onMousedown: _withModifiers(($event) => ($setup.selectCategoria(cat)), ["prevent"]),
                                                                        innerHTML: cat.highlightedNombre
                                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_66));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ])
                                            ], 4 /* STYLE */),
                                            ($setup.creationMode === 'individual')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                                    _hoisted_68,
                                                    _createElementVNode("div", _hoisted_69, [
                                                        _createVNode(_component_TagIcon, {
                                                            size: 18,
                                                            class: "input-icon"
                                                        }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => (($setup.currentForm.nombre) = $event)),
                                                            placeholder: "Ej: Amortiguador Delantero",
                                                            required: $setup.creationMode === 'individual',
                                                            class: "form-control"
                                                        }, null, 8 /* PROPS */, _hoisted_70), [
                                                            [_vModelText, $setup.currentForm.nombre]
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.creationMode === 'bulk')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                                    ($setup.currentForm.departamentoID > 0 && $setup.currentForm.categoriaID > 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                                            _hoisted_73,
                                                            _createElementVNode("div", _hoisted_74, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bulkNombresList, (nombre, index) => {
                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                        key: index,
                                                                        style: { "display": "flex", "gap": "10px", "margin-bottom": "10px" }
                                                                    }, [
                                                                        _createElementVNode("div", _hoisted_75, [
                                                                            _createVNode(_component_TagIcon, {
                                                                                size: 18,
                                                                                class: "input-icon"
                                                                            }),
                                                                            _withDirectives(_createElementVNode("input", {
                                                                                type: "text",
                                                                                "onUpdate:modelValue": ($event) => (($setup.bulkNombresList[index]) = $event),
                                                                                placeholder: "Ej: Amortiguador Delantero",
                                                                                required: $setup.creationMode === 'bulk',
                                                                                class: "form-control"
                                                                            }, null, 8 /* PROPS */, _hoisted_76), [
                                                                                [_vModelText, $setup.bulkNombresList[index]]
                                                                            ])
                                                                        ]),
                                                                        ($setup.bulkNombresList.length > 1)
                                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                                key: 0,
                                                                                type: "button",
                                                                                onClick: ($event) => ($setup.removeBulkInput(index)),
                                                                                class: "btn-icon btn-delete",
                                                                                style: { "flex-shrink": "0", "align-self": "center" },
                                                                                title: "Eliminar"
                                                                            }, [
                                                                                _createVNode(_component_TrashIcon, { size: 18 })
                                                                            ], 8 /* PROPS */, _hoisted_77))
                                                                            : _createCommentVNode("v-if", true)
                                                                    ]));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ]),
                                                            _createElementVNode("button", {
                                                                type: "button",
                                                                onClick: _cache[26] || (_cache[26] =
                                                                    //@ts-ignore
                                                                    (...args) => ($setup.addBulkInput && $setup.addBulkInput(...args))),
                                                                style: { "background": "transparent", "border": "1px dashed #cbd5e1", "color": "#3b82f6", "padding": "10px", "width": "100%", "border-radius": "8px", "font-weight": "600", "cursor": "pointer", "display": "flex", "align-items": "center", "justify-content": "center", "gap": "8px", "transition": "0.2s" },
                                                                onmouseover: "this.style.background='#f8fafc'",
                                                                onmouseout: "this.style.background='transparent'"
                                                            }, [
                                                                _createVNode(_component_PlusIcon, { size: 18 }),
                                                                _createTextVNode(" Agregar otro repuesto ")
                                                            ])
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                                            _createVNode(_component_InfoIcon, {
                                                                size: 18,
                                                                style: { "color": "#d97706" }
                                                            }),
                                                            _hoisted_79
                                                        ]))
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_80, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[27] || (_cache[27] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                                class: "btn-cancel-modal",
                                                disabled: $setup.isSaving
                                            }, "Cancelar", 8 /* PROPS */, _hoisted_81),
                                            _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn-save-modal",
                                                disabled: $setup.isSaving,
                                                style: { "display": "flex", "align-items": "center", "justify-content": "center", "gap": "8px" }
                                            }, [
                                                ($setup.isSaving)
                                                    ? (_openBlock(), _createBlock(_component_Loader2Icon, {
                                                        key: 0,
                                                        class: "spinner-icon",
                                                        size: 18,
                                                        style: { "animation": "spin 1s linear infinite" }
                                                    }))
                                                    : _createCommentVNode("v-if", true),
                                                _createElementVNode("span", null, _toDisplayString($setup.isSaving ? ($setup.isEditing ? 'Guardando...' : 'Creando...') : ($setup.isEditing ? 'Guardar Cambios' :
                                                    'Crear Repuesto')), 1 /* TEXT */)
                                            ], 8 /* PROPS */, _hoisted_82)
                                        ])
                                    ], 32 /* NEED_HYDRATION */)
                                ], 2 /* CLASS */)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isModalOpenDesplegable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                _createElementVNode("div", _hoisted_84, [
                                    _createElementVNode("div", _hoisted_85, [
                                        _createElementVNode("div", _hoisted_86, [
                                            _createElementVNode("div", _hoisted_87, [
                                                _createVNode(_component_ListIcon, {
                                                    size: 24,
                                                    class: "text-purple"
                                                })
                                            ]),
                                            _createElementVNode("div", null, [
                                                _hoisted_88,
                                                _createElementVNode("span", _hoisted_89, [
                                                    _createTextVNode("Para: "),
                                                    _createElementVNode("strong", null, _toDisplayString($setup.currentRepuesto?.nombre), 1 /* TEXT */)
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[29] || (_cache[29] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeDesplegableModal && $setup.closeDesplegableModal(...args))),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_90, [
                                        _createElementVNode("div", _hoisted_91, [
                                            _hoisted_92,
                                            _createElementVNode("div", _hoisted_93, [
                                                _createElementVNode("div", _hoisted_94, [
                                                    _createVNode(_component_SearchIcon, {
                                                        size: 18,
                                                        class: "input-icon"
                                                    }),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => (($setup.searchDesplegables) = $event)),
                                                        onInput: _cache[31] || (_cache[31] =
                                                            //@ts-ignore
                                                            (...args) => ($setup.searchDesplegable && $setup.searchDesplegable(...args))),
                                                        placeholder: "Buscar atributo (ej: Color, Talla)...",
                                                        class: "form-control"
                                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                        [_vModelText, $setup.searchDesplegables]
                                                    ])
                                                ]),
                                                ($setup.filteredDesplegables.length > 0 && $setup.searchDesplegables.length >= 2)
                                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_95, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredDesplegables, (item) => {
                                                            return (_openBlock(), _createElementBlock("li", {
                                                                key: item.nombreAtributoID,
                                                                onClick: ($event) => ($setup.selectDesplegableToAdd(item))
                                                            }, _toDisplayString(item.nombreAtributo), 9 /* TEXT, PROPS */, _hoisted_96));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]))
                                                    : _createCommentVNode("v-if", true),
                                                _createElementVNode("button", {
                                                    onClick: _cache[32] || (_cache[32] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.addDesplegableToRepuesto && $setup.addDesplegableToRepuesto(...args))),
                                                    class: "btn-add-value",
                                                    disabled: !$setup.selectedDesplegableToAdd
                                                }, [
                                                    _createVNode(_component_PlusIcon, { size: 16 }),
                                                    _createTextVNode(" Vincular ")
                                                ], 8 /* PROPS */, _hoisted_97)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_98, [
                                            _createElementVNode("table", _hoisted_99, [
                                                _hoisted_100,
                                                _createElementVNode("tbody", _hoisted_101, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.desplegablesList, (item) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            key: item.atributoID,
                                                            class: "sortable-item"
                                                        }, [
                                                            _createElementVNode("td", _hoisted_102, [
                                                                _createVNode(_component_MoveIcon, { size: 16 })
                                                            ]),
                                                            _createElementVNode("td", null, _toDisplayString(item.nombreAtributo.nombreAtributo), 1 /* TEXT */),
                                                            _createElementVNode("td", _hoisted_103, [
                                                                _createElementVNode("button", {
                                                                    onClick: ($event) => ($setup.confirmDeleteDesplegableItem(item.atributoID)),
                                                                    class: "btn-icon btn-delete-mini",
                                                                    title: "Desvincular"
                                                                }, [
                                                                    _createVNode(_component_TrashIcon, { size: 14 })
                                                                ], 8 /* PROPS */, _hoisted_104)
                                                            ])
                                                        ]));
                                                    }), 128 /* KEYED_FRAGMENT */)),
                                                    ($setup.desplegablesList.length === 0)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_105, _hoisted_107))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ]),
                                            ($setup.desplegablesList.length > 1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                                    _createVNode(_component_MoveIcon, { size: 14 }),
                                                    _createTextVNode(" Arrastra para reordenar ")
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_109, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[33] || (_cache[33] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeDesplegableModal && $setup.closeDesplegableModal(...args))),
                                            class: "btn-save-modal full-width"
                                        }, " Finalizar Configuración ")
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isExportModalOpen)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-overlay",
                                onClick: _cache[43] || (_cache[43] = _withModifiers(
                                //@ts-ignore
                                (...args) => ($setup.closeExportModal && $setup.closeExportModal(...args)), ["self"]))
                            }, [
                                _createElementVNode("div", _hoisted_110, [
                                    _createElementVNode("div", _hoisted_111, [
                                        _createElementVNode("div", _hoisted_112, [
                                            _createElementVNode("div", _hoisted_113, [
                                                _createVNode(_component_DownloadIcon, {
                                                    size: 24,
                                                    class: "text-excel"
                                                })
                                            ]),
                                            _hoisted_114
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[34] || (_cache[34] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeExportModal && $setup.closeExportModal(...args))),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_115, [
                                        _hoisted_116,
                                        _createElementVNode("div", _hoisted_117, [
                                            _hoisted_118,
                                            _createElementVNode("div", _hoisted_119, [
                                                _createElementVNode("label", {
                                                    class: _normalizeClass(["export-format-card", { active: $setup.exportConfig.format === 'excel' }])
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "radio",
                                                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => (($setup.exportConfig.format) = $event)),
                                                        value: "excel",
                                                        hidden: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelRadio, $setup.exportConfig.format]
                                                    ]),
                                                    _hoisted_120
                                                ], 2 /* CLASS */),
                                                _createElementVNode("label", {
                                                    class: _normalizeClass(["export-format-card", { active: $setup.exportConfig.format === 'pdf' }])
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "radio",
                                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => (($setup.exportConfig.format) = $event)),
                                                        value: "pdf",
                                                        hidden: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelRadio, $setup.exportConfig.format]
                                                    ]),
                                                    _hoisted_121
                                                ], 2 /* CLASS */)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_122, [
                                            _hoisted_123,
                                            _createElementVNode("div", _hoisted_124, [
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => (($setup.exportConfig.sortColumn) = $event)),
                                                    class: "form-control",
                                                    style: { "background-color": "#f8fafc", "border": "1px solid #e2e8f0", "border-radius": "8px", "padding": "12px", "font-size": "0.95rem", "color": "#1e293b", "outline": "none", "transition": "border-color 0.2s, box-shadow 0.2s", "cursor": "pointer" }
                                                }, _hoisted_128, 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, $setup.exportConfig.sortColumn]
                                                ]),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event) => (($setup.exportConfig.sortDirection) = $event)),
                                                    class: "form-control",
                                                    style: { "background-color": "#f8fafc", "border": "1px solid #e2e8f0", "border-radius": "8px", "padding": "12px", "font-size": "0.95rem", "color": "#1e293b", "outline": "none", "transition": "border-color 0.2s, box-shadow 0.2s", "cursor": "pointer" }
                                                }, _hoisted_131, 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, $setup.exportConfig.sortDirection]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_132, [
                                            _hoisted_133,
                                            _createElementVNode("div", _hoisted_134, [
                                                _hoisted_135,
                                                _createVNode(_component_draggable, {
                                                    modelValue: $setup.availableColumns,
                                                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => (($setup.availableColumns) = $event)),
                                                    "item-key": "name",
                                                    handle: ".drag-handle",
                                                    class: "draggable-columns-list"
                                                }, {
                                                    item: _withCtx(({ element: col, index }) => [
                                                        _createElementVNode("label", {
                                                            class: _normalizeClass(["column-checkbox-card", { active: $setup.exportConfig.selectedColumns.includes(col.name) }])
                                                        }, [
                                                            _createElementVNode("div", _hoisted_136, _toDisplayString(index + 1), 1 /* TEXT */),
                                                            _createElementVNode("div", _hoisted_137, [
                                                                _createVNode(_component_GripVerticalIcon, { size: 16 })
                                                            ]),
                                                            _createElementVNode("div", _hoisted_138, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    type: "checkbox",
                                                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event) => (($setup.exportConfig.selectedColumns) = $event)),
                                                                    value: col.name
                                                                }, null, 8 /* PROPS */, _hoisted_139), [
                                                                    [_vModelCheckbox, $setup.exportConfig.selectedColumns]
                                                                ]),
                                                                _hoisted_140
                                                            ]),
                                                            _createElementVNode("div", _hoisted_141, [
                                                                _createElementVNode("span", _hoisted_142, _toDisplayString(col.name), 1 /* TEXT */)
                                                            ])
                                                        ], 2 /* CLASS */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue"])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_143, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[41] || (_cache[41] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeExportModal && $setup.closeExportModal(...args))),
                                            class: "btn-cancel-modal"
                                        }, "Cancelar"),
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[42] || (_cache[42] =
                                                //@ts-ignore
                                                (...args) => ($setup.handleExport && $setup.handleExport(...args))),
                                            class: "btn-save-modal btn-excel",
                                            disabled: $setup.isExporting
                                        }, [
                                            ($setup.isExporting)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_145, "Generando..."))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                                    _createVNode(_component_FileTextIcon, { size: 18 }),
                                                    _hoisted_147
                                                ]))
                                        ], 8 /* PROPS */, _hoisted_144)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ])
    ]));
}
